// 时间戳转（年-月-日 时：分：秒）
export const dateFormatToSecond = (originVal) => {
  if(originVal&&originVal!=''){
      var date = new Date();
      date.setTime(originVal * 1000); //时间戳为微秒*1,毫秒*1000
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? ('0' + m) : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      var h = date.getHours();
      h = h < 10 ? ('0' + h) : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? ('0' + minute) : minute;
      second = second < 10 ? ('0' + second) : second;
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
  } else{
    return ''
  }
}

// 时间戳转（年-月-日 时：分）
export const dateFormatToMin = (val) => {
  if (val !== '' && val !== null && val !== undefined) {
    const dt = new Date(val * 1000)
    const y = dt.getFullYear()
    const m = (dt.getMonth() + 1 + '').padStart(2, '0')
    const d = (dt.getDate() + '').padStart(2, '0')
    const hh = (dt.getHours() + '').padStart(2, '0')
    const mm = (dt.getMinutes() + '').padStart(2, '0')
    return `${y}-${m}-${d} ${hh}:${mm}`
  } else {
    return ''
  }
}

// 时间戳转（年-月-日）
export const dateFormatToDay = (originVal) => {
  if(originVal&&originVal!=''){
    var date = new Date();
    date.setTime(originVal * 1000); //时间戳为微秒*1,毫秒*1000
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    return y + '-' + m + '-' + d;
  } else{
    return ''
  }
}

// 10转是否
export const isOrNotFilter = (originVal) =>{
  switch(originVal){
    case '0':
      return '否';
    case '1':
      return '是';
    default:
      return '';
  }
}

// 空值转--
export const empty = (value) => {
  return value === null || value === undefined || value === '' ? '--' : value
}